import React, { Component } from 'react';
import StripeCheckout from 'react-stripe-checkout';

import {Table, TableBody, TableRow, TableRowColumn} from 'material-ui/Table';
import {Card, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

import Config from '../../conf';
import {ConfirmDetails as styles} from './sms_payment.css';

import 'whatwg-fetch';
import moment from 'moment';

class ConfirmDetails extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      confirmDisabled: false,
      error: false,

      paymentComplete: false
    };

    this.retry = this.retry.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
    this.onToken = this.onToken.bind(this);
    this.confirmClicked = this.confirmClicked.bind(this);
  }

  confirmClicked() {
    this.setState({
      confirmDisabled: true
    });
    setTimeout(() => {
      this.setState({
        confirmDisabled: false
      });
    }, 3000);
  }

  onToken(token) {
    // set loading status
    this.setState({
      loading: true
    });

    const body = {
      tokenId: token.id,
      linkId: this.props.details.linkId,
    };
    fetch(Config.BACKEND_API_URL + 'sms-bot/stripe', {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then((response) => {
      return response.json();
    }).then((data) => {
      console.log('response was: ' + JSON.stringify(data, null, 2));
      if (data.status === 200) {
        this.setState({
          paymentComplete: true
        });
      } else {
        throw Error('response status from backend was ' + data.status + ' (data = ' + JSON.stringify(data) + ')');
      }
    }).catch((err) => {
      // set error
      this.setState({
        error: true
      });
      console.log('err:', err);
    });
  };

  refreshPage() {
    location.reload();
  }

  retry() {
    this.setState({
      confirmDisabled: false,
      loading: false,
      error: false
    });
  }

  render() {
    const prettyWashTimeStart = moment(this.props.details.washDateStart).format('dddd Do of MMMM, YYYY h:mm A');
    const prettyWashTimeEnd = moment(this.props.details.washDateEnd).format('h:mm A');
    const prettyWashTimeString = `${prettyWashTimeStart} - ${prettyWashTimeEnd}`;

    const customerRows = [
      { name: 'Full Name', value: this.props.details.name },
      { name: 'Email Address', value: this.props.details.email },
      { name: 'Mobile Number', value: this.props.details.phone },
    ];

    const bookingRows = [
      { name: 'Number Plate', value: this.props.details.numberPlate },
      { name: 'Address', value: this.props.details.address },
      { name: 'Wash Date', value: `${prettyWashTimeString}` },
      { name: 'Wash Type', value: this.props.details.washType },
      { name: 'Cost', value: `$${this.props.details.cost}` },
    ];

    return (
      <div>
      {!this.state.error && !this.state.loading && !this.state.paymentComplete &&
        <Card style={styles.card}>
          <h2 style={styles.title}>
            SMS Booking Payment
          </h2>

          {this.props.details.isSmallScreen ?
            <div>
              <h2>Booking details</h2>
              {bookingRows.map((row) => {
                return (
                  <p key={row.name}>
                    <strong>{row.name}</strong>:
                    <br />
                    {row.value}
                  </p>
                );
              })}
              <h2>Your details</h2>
              {customerRows.map((row) => {
                return (
                  <p key={row.name}>
                    <strong>{row.name}</strong>:
                    <br />
                    {row.value}
                  </p>
                );
              })}
            </div>
          :
            <div>
              <h3>Booking details</h3>
              <Table selectable={false} style={styles.table}>
                <TableBody displayRowCheckbox={false}>
                  {bookingRows.map((row) => {
                    return (
                      <TableRow key={row.name}>
                        <TableRowColumn style={styles.nameCol}>{row.name}</TableRowColumn>
                        <TableRowColumn style={styles.valueCol}>{row.value}</TableRowColumn>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              <h3>Your details</h3>
              <Table selectable={false} style={styles.table}>
                <TableBody displayRowCheckbox={false}>
                  {customerRows.map((row) => {
                    return (
                    <TableRow key={row.name}>
                    <TableRowColumn style={styles.nameCol}>{row.name}</TableRowColumn>
                    <TableRowColumn style={styles.valueCol}>{row.value}</TableRowColumn>
                    </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          }

          <StripeCheckout
            name={'WipeHero'}
            image="/images/logo_stripe.png"
            currency="AUD"
            token={this.onToken}
            allowRememberMe={false}
            stripeKey={Config.STRIPE_API_KEY}
            email={this.props.details.email}
          >
            <RaisedButton
              style={styles.button}
              label="Pay"
              primary={true}
              onClick={this.confirmClicked}
              disabled={this.state.confirmDisabled}
            />
          </StripeCheckout>

        </Card>
      }
      {this.state.loading && !this.state.paymentComplete && !this.state.error &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Processing your payment...</h2>
          <CardText>
            <CircularProgress />
          </CardText>
        </Card>
      }
      {this.state.paymentComplete &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Done!</h2>
          <CardText>
            <p>Your payment has been received. We hope you've enjoyed our service!</p>
            <p>
              When you require another carwash in the future, simply spend 2 minutes to make a booking on our main
              website at <a href="https://www.wipehero.com.au/">www.wipehero.com.au</a> and <strong>we'll come to
              you!</strong>
            </p>
          </CardText>
        </Card>
      }
      {this.state.error && !this.state.paymentComplete &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Error</h2>
          <CardText>
            <div>
              Your credit card has been declined, please try again. If this issue persists, please contact us on
              1300 791 421 or email hello@wipehero.com
            </div>
            <div>
              <RaisedButton
                style={{...styles.button,...{marginTop: 40}}}
                label="Retry"
                primary={true}
                onClick={this.retry}
              />
            </div>
          </CardText>
        </Card>
      }
      </div>
    );
  }
}

export default ConfirmDetails;



// WEBPACK FOOTER //
// ./src/app/components/sms_payment/ConfirmDetails.js